/**
 * ブラウザのダウンロードとしてファイルを保存する。
 * ZIP 依存を増やさず、1 ファイルずつ落とす。
 */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // iOS は revoke が早すぎると失敗することがある
    window.setTimeout(() => URL.revokeObjectURL(url), 2_000);
  }
}

export function downloadBytes(
  filename: string,
  data: ArrayBuffer | Uint8Array,
  mime = 'application/octet-stream',
): void {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  // BlobPart として渡すため、裏の ArrayBuffer を正確な範囲で切り出す
  const copy = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
  downloadBlob(filename, new Blob([copy as BlobPart], { type: mime }));
}

export function safeDownloadName(name: string, fallback = 'download.bin'): string {
  const trimmed = name.trim().replace(/[\\/:*?"<>|]/g, '_');
  return trimmed || fallback;
}
